import { GoogleLoginButton } from "react-social-login-buttons";
import { LoginSocialGoogle } from "reactjs-social-login";
import logo from "../../assets/logo.png";
import { useEffect, useState } from "react";
import Home from "../Home";
function Login() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const _user = localStorage.getItem("fitgptuser");
    if (_user) {
      setUser(JSON.parse(_user));
    }
  }, []);
  const handleClearLocalStorage = () => {
    localStorage.setItem("fitgptuser", null);
    window.location.reload();
  };

  return (
    <div>
      <div className="flex items-center p-1 justify-between gap-2">
        <h1 className="text-center font-bold text-3xl">Fit-GPT</h1>
        {user && (
          <button
            className="p-2 border border-white rounded-md m-2"
            onClick={handleClearLocalStorage}
          >
            Logout
          </button>
        )}
      </div>
      <div>
        {user ? (
          <div>
            <Home user={user} />
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center">
            <img src={logo} alt="" className="h-[30vh]" />
            <LoginSocialGoogle
              className="mx-auto"
              client_id="522401362097-40km33v4cso9cs494jp6vlticfk6635m.apps.googleusercontent.com"
              scope="openid profile email"
              discoveryDocs="claims_supported"
              access_type="offline"
              onResolve={({ provider, data }) => {
                console.log(provider, data);
                localStorage.setItem("fitgptuser", JSON.stringify(data));
                setUser(data);
              }}
              onReject={(err) => {
                console.log(err);
              }}
            >
              {/* <GoogleLoginButton
                style={{
                  color: "#000",
                  //   fontSize: "0.8rem",
                  border: "1px solid #000",
                  background: "transparent",
                }}
              /> */}
              <button className="flex justify-between items-center p-3 gap-4 hover:bg-white/30 border rounded-md border-white">
                <img
                  src={
                    "https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                  }
                  className="h-6"
                  alt=""
                />
                Login with Google
              </button>
            </LoginSocialGoogle>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
